import { css } from '@emotion/core'
import styled, { ThemeProps, Theme } from '@themes/theme'
import { mq, TxtLimit } from '@styles/base.style'

export const Hit = (theme: Theme) =>
  css`
    color: ${theme.color.blue};
    &::before {
      background: ${theme.color.blue};
    }
  `
export const Miss = (theme: Theme) =>
  css`
    color: ${theme.color.red};
    margin-left: 16px;
    &::before {
      background: ${theme.color.red};
    }
  `
export const SpecialCase = (theme: Theme) =>
  css`
    color: ${theme.color.purple};
    &::before {
      background: ${theme.color.purple};
    }
  `
// 아코디언 하위 - 리그, 날짜, 팀
export const BettingHistoryLeagueWrap = styled.div`
  position: relative;
  padding: 0 24px;
  /* 밑 구분선 */
  &::before {
    content: '';
    display: block;
    position: absolute;
    right: 14px;
    bottom: 0;
    width: calc(100% - 92px);
    height: 1px;
    background: ${props => props.theme.color.modalSubBg2};
    box-shadow: 0 1px 1px rgba(255, 255, 255, .7);
  }
  &:last-of-type::before {
    display: none;
  }
  .match-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 7px;
    .date {
      color: ${props => props.theme.color.modalTxt};
      font-weight: ${props => props.theme.fontW.medium};
    }
    .info-txt {
      color: ${props => props.theme.color.modalgray};
    }
    .score-btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      line-height: 1.6rem;
      color: ${props => props.theme.color.red};
      font-weight: ${props => props.theme.fontW.medium};
      border-radius: 0;
      .overtime {
        display: inline-block;
        width: 32px;
        height: 21px;
        line-height: 21px;
        margin-right: 7px;
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.modalTxt};
        background: ${props => props.theme.color.modalSubBg2};
        border-radius: 4px;
      }
      .value {
        color: ${props => props.theme.color.modalTxt};
        font-weight: ${props => props.theme.fontW.medium};
        &.win {
          color: ${props => props.theme.color.red};
        }
      }
      .center {
        margin: 0 2px;
        color: ${props => props.theme.color.modalTxt};
        font-weight: ${props => props.theme.fontW.medium};
      }
      &.underline {
        .score {
          border-bottom: 1px solid ${props => props.theme.color.gray};
          padding-left: 20px;
          position: relative;
          line-height: 18px;
        }
        &.no-record-btn {
          .score {
            padding-left: 0;
          }
        }
      }
    }
    .request-btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 63px;
      height: 17px;
      margin-left: 10px;
      background: ${props => props.theme.color.modalyellow};
      border-radius: 4px;
      transform: translateY(1px);
      svg {
        width: 10px;
        height: auto;
        margin-right: 3px;
      }
      &.complete {
        background: ${props => props.theme.color.modalDarkBg};
      }
    }
    .match-record-btn {
      position: absolute;
      left: -6px;
      top: -6px;
      border-radius: 0;
      background: none;
      width: calc(100% + 12px);
      height: calc(100% + 14px);
      svg {
        width: 28px;
        position: absolute;
        left: 1px;
        top: 1px;
        .fill{
          fill: #2C3340 !important;
        }
      }
    }
  }
  &.shared-list {
    //border: 1px solid red;
    background: ${props => props.theme.color.themeTxt};
  }
`
export const ListItemFoldWrap = styled.ul`
  position: relative;
  padding: 9px 0 14px;
  &:not(:last-of-type) {
    &::before {
      content: '';
      display: block;
      position: absolute;
      right: 0;
      bottom: 0;
      width: calc(100% - 58px);
      height: 1px;
      background: ${props => props.theme.color.modalSubBg2};
      box-shadow: 0 1px 1px rgba(255, 255, 255, .7);
    }
  }
  .list-item-fold-item {
    display: flex;
    align-items: center;
    .hit-state {
      min-width: 44px;
      height: 22px;
      .state {
        display: inline-block;
        width: 100%;
        height: inherit;
        line-height: 23px;
        text-align: center;
        border-radius: 4px;
      }
      .success {
        color: ${props => props.theme.color.themeTxt};
        background: ${props => props.theme.color.secondaryBg};
      }
      .fail {
        color: ${props => props.theme.color.themeTxt};
        background: ${props => props.theme.color.gray};
      }
      .cancel {
        color: ${props => props.theme.color.themeTxt};
        background: ${props => props.theme.color.purple};
        // 베팅취소
        &.bettor {
          font-size: ${props => props.theme.font.small};
          background: ${props => props.theme.color.disableTxt};
        }
      }
      .ongoing {
        color: ${props => props.theme.color.modalTxt};
        border: 1px solid ${props => props.theme.color.modalTxt};
      }
    }
    .select-match {
      flex: 1;
      display:flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: nowrap;
      width: calc(100% - 58px);
      line-height: 2.7rem;
      padding-left: 14px;
      color: ${props => props.theme.color.modalTxt};
      font-size: ${props => props.theme.font.title};
      .live-tag-icon {
        width: auto;
        height: 14px;
        margin-right: 3px;
        transform: translateY(5px);
      }
      .select-wrap {
        flex: 1;
        ${TxtLimit};
        .item {
          display: block;
          color: ${props => props.theme.color.modalTxt};
          font-size: ${props => props.theme.font.title};
          text-align: left;
          ${TxtLimit};
        }
      }
      .outcome-rate {
        width: auto;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.title};
        text-align: right;
      }
    }
    &.select-rate {
      margin-bottom: 7px;
      .sport-talk-item {
        position: absolute;
        right: -7px;
        bottom: 3px;
        &--btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
        }
        &--icon-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: ${props => props.theme.color.disableBg};
          svg {
            width: 13px;
            height: auto;
            transform: translate(0, 0.5px);
          }
        }
        &--bubble-message {
          width: 278px;
          height: auto;
          position: absolute;
          bottom: 28px;
          right: -14px;
          z-index: 1;
          &-img {
            width: 100%;
            height: auto;
          }
          &-close-btn {
            position: absolute;
            bottom: 53px;
            right: 7px;
            width: 28px;
            height: 28px;
          }
        }
      }
    }
    &.select-type, &.select-team {
      padding-left: 58px;
    }
    &.select-type {
      margin-bottom: 2px;
      line-height: 1.8rem;
      color: ${props => props.theme.color.disableTxt2};
      font-weight: ${props => props.theme.fontW.medium};
      .value {
        color: ${props => props.theme.color.secondaryBg};
        font-weight: ${props => props.theme.fontW.medium};
      }
    }
    &.select-team {
      line-height: 1.8rem;
      img {
        width: 14px;
        height: auto;
        margin-right: 4px;
      }
      .team-name {
        ${TxtLimit};
        text-align: left;
        width: calc(100% - 50px);
        color: ${props => props.theme.color.disableTxt2};
        font-weight: ${props => props.theme.fontW.medium};
      }
    }
  }
  .oz-type {
    color: ${props => props.theme.color.gray};
  }
    
    .button-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    
  .checkbox-wrapper {
      display: inline-block;
      margin-left: 10px;
  }
`
// type별 wrap
export const Wrap = (theme: Theme) =>
  css`
    /* position: relative;
    .oz-type {
      color: ${theme.color.gray};
    } */
  `
export const OddsWrap = styled.div`
  display: grid;
  grid-template-columns: 3;
`
export const League = styled.span``
export const SpecialGame = styled.span`
  float: left;
  color: ${props => props.theme.color.themeTxt};
`
export const Info = styled.span`
  height: 20px;
  line-height: 2rem;
`
export const TeamWrap = styled.div`
  line-height: 2.8rem;
  &.special {
    top: 0;
    width: calc(100% - 70px);
  }
  &::after {
    content: '';
    display: block;
    clear: both;
  }
`
export const TeamNameTxt = styled.span`
  float: left;
  width: auto;
  max-width: calc(50% - 35px);
  color: ${props => props.theme.color.themeTxt};
  ${mq[0]} {
    max-width: 40%;
  }

  &.special-num {
    margin-left: 14px;
    font-size: ${props => props.theme.font.medium};
    color: ${props => props.theme.color.gray};
    .point {
      font-size: ${props => props.theme.font.medium};
      color: ${props => props.theme.color.red};
    }
  }
`
// 아코디언 하위 팀 점수 or VS
export const Score = styled.span`
  width: auto;
  float: left;
  margin: 0 8px;
  text-align: center;
  color: ${props => props.theme.color.gray};
  font-size: ${props => props.theme.font.large};
`
export const ResultNum = styled.span`
  color: ${props => props.theme.color.gray};
  font-size: ${props => props.theme.font.large};
`
export const Win = (theme: Theme) =>
  css`
    color: ${theme.color.red};
  `

const TxtStyle = (props: ThemeProps) => css`
  color: ${props.theme.color.gray};
  font-size: ${props.theme.font.small};
`
export const MyPickTxt = styled.span`
  ${TxtStyle};
`
export const ResultTxt = styled.span`
  ${TxtStyle};
  margin-left: 10px;
`
export const TypeTxt = styled.span`
  height: 20px;
  line-height: 2rem;
  color: ${props => props.theme.color.themeTxt};
  &.select {
    margin-right: 5px;
  }
  /* 기준점 */
  .point {
    &.handicap {
      color: ${props => props.theme.color.handicap};
    }
    &.underover {
      color: ${props => props.theme.color.underover};
    }
  }
`
export const Txt = styled.span`
  position: relative;
  margin-left: 22px;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50px;
    height: 18px;
    border-radius: 50px;
    transform: translate(-50%, -52%);
    opacity: 0.3;
  }
`
export const MatchResultWrap = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  line-height: 4rem;
  margin: 4px 0 0;
`
const MatchResultStyle = css`
  position: relative;
  height: 31px;
  line-height: 3.2rem;
  border: none;
  border-radius: 50px;
`
export const MatchResult = styled.span`
  ${MatchResultStyle};
  width: 41%;
  padding: 0 6px 0 4px;
  font-size: ${props => props.theme.font.small};
  background: ${props => props.theme.color.subBg};
`
export const MatchResultCenter = styled.span`
  ${MatchResultStyle};
  width: 13.4%;
  margin: 0 auto;
  padding: 0;
  text-align: center;
  font-size: ${props => props.theme.font.small};
  background: ${props => props.theme.color.subBg};
`
export const Team = styled.span`
  float: left;
  width: 74%;
  max-width: 100px;
  text-align: left;
`
export const TeamName = styled.p`
  float: left;
  width: 100%;
  padding: 0 0 0 2px;
  font-size: ${props => props.theme.font.small};
`
export const TeamIco = styled.span`
  position: relative;
  top: 8px;
  float: left;
  width: 20%;
  img {
    display: block;
    width: 14px;
    max-height: 14px;
    margin: 0 auto;
  }
`
const NumStyle = (props: ThemeProps) =>
  css`
    color: ${props.theme.color.primary};
    font-size: ${props.theme.font.small};
  `
export const Num = styled.span`
  ${NumStyle};
  width: 25%;
`
export const PickSelect = (theme: Theme) => css`
  border: 1px solid ${theme.color.gray} !important;
`
export const PickHit = (theme: Theme) => css`
  background: ${theme.color.blue} !important;
  border: 1px solid ${theme.color.gray} !important;
  p,
  span {
    color: ${theme.color.themeTxt};
  }
`
export const PickMiss = (theme: Theme) => css`
  background: ${theme.color.red} !important;
  p,
  span {
    color: ${theme.color.themeTxt};
  }
`
export const PickSpecialCase = (theme: Theme) => css`
  background: ${theme.color.purple} !important;
  p,
  span {
    color: ${theme.color.themeTxt};
  }
`
export const ClubName = styled.span`
  font-size: ${props => props.theme.font.small};
`
export const VisitBtnStyle = (theme: Theme) => css`
  width: 56px;
  height: 24px;
  margin-left: 8px;
  line-height: 24px;
  font-size: ${theme.font.small};
`
export const PickType = styled.span`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 18px;
  line-height: 1.8rem;
  text-align: center;
  font-size: ${props => props.theme.font.small};
  &::before {
    content:'';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: inherit;
    height: inherit;
    border-radius: 50px;
    transform: translate(-50%,-54%);
  }
`
export const HitStyle = (theme: Theme) =>
  css`
    color: ${theme.color.blue};
    &::before {
      border:1px solid ${theme.color.blue};
    }
  `
export const StandbyStyle = (theme: Theme) =>
  css`
    color: ${theme.color.themeTxt};
    &::before {
      border:1px solid${theme.color.themeTxt};
    }
  `
export const MissStyle = (theme: Theme) =>
  css`
    color: ${theme.color.red};
    &::before {
      border:1px solid ${theme.color.red};
    }
  `
export const SpecialCaseStyle = (theme: Theme) =>
  css`
    color: ${theme.color.purple};
    &::before {
      border:1px solid ${theme.color.purple};
    }
  `
export const PickBtnStyle = (theme: Theme) => css`
  float: right;
  /* position: absolute;
  top: -4px;
  right: 0; */
  width: 56px;
  height: 24px;
  line-height: 2.4rem;
  font-size: ${theme.font.small};
  &.pick {
    margin-left: 6px;
  }
`
export const DateSpan = styled.span`
  position: relative;
  top: 1px;
  margin: 0 4px;
  color: ${props => props.theme.color.gray};
`
export const BetCouponStyle = (theme: Theme) => css`
  position: relative;
  width: 45px;
  height: 20px;
  line-height: 2rem;
  background: none;
  border-radius: 0;

  .bet-tag {
    font-size: ${theme.font.small};
    height: 20px;
    padding: 0 6px;
    line-height: 2rem;
    border: 1px solid #714C4C;
    svg {
      width: 8px;
      /* transform: translateY(-10%); */
    }
  }
`
export const FoldTxt = styled.span`
  float: left;
  margin-right: 6px;
  /* font-size: ${props => props.theme.font.small}; */
  color: ${props => props.theme.color.gray};
`
export const FoldNum = styled.span`
  float: left;
`
export const CircleStyle = styled.span`
  position: relative;
  top: 1px;
  float: left;
  width: 10px;
  height: 10px;
  margin-left: 4px;
  transition: all 0.3s ease-in-out;
`
export const BetNum = styled.span`
  color: ${props => props.theme.color.yellow};
`
export const X = styled.span`
  color: ${props => props.theme.color.gray};
`
export const Equal = styled.span`
  text-align: center;
`
export const Money = styled.span`
  float: right;
  width: auto;
  max-width: 50%;
  text-align: right;
`
export const GmoneyStyle = styled.span`
  position: relative;
  top: 1px;
  width: 10px;
  margin-left: 4px;
  float: right;
`
export const RowStyle = css`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
  height: 18px;
  margin-top: 9px;
  .col {
    float: left;
    line-height: 1.8rem;
  }
  .fold.col {
    width: 63px;
    /* border: 1px solid green; */
  }
  .wrap.col {
    float: right;
    width: calc(100% - 63px);
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    .col {
      width: auto;
      &::after {
        content: '';
        display: block;
        clear: both;
      }
    }
    .rate.col {
      max-width: 25%;
    }
    .x.col {
      width: 12px;
      margin: 0 8px;
    }
    .equal.col {
      width: 7px;
      margin: 0 8px;
    }
    /* 베팅 쿠폰 이미지 */
    .bet-coupon-img {
      position: relative;
      top: 1px;
      width: 18px;
      height: 16px;
      margin-left: 2px;
      float: right;
      transform: rotate(-10deg);
    }
  }
`
export const BettingHistoryHeader = styled.div`
  position: relative;
  margin-bottom: 5px;
  padding-bottom: 12px;
  border-radius: 18px;
  background: ${props => props.theme.color.modalBg};
  border: 1px solid rgba(238, 233, 238, .5);
  .top-info {
    padding: 14px 14px 0 21px;
    line-height: 1.8rem;
    color: ${props => props.theme.color.mainColor};
    font-weight:  ${props => props.theme.fontW.medium};
    text-align: left;
    .do-bet-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 54px;
    height: 28px;
    }
    & > span:first-of-type:not(.additional-dividend-mark) {
      margin-left: 6px;
    }
    & > span:nth-of-type(2):not(.additional-dividend-mark) {
      margin-left: 9px;
    }
    .betting-history.bet-coupon-tag {
      display: inline-block;
      width: auto;
      height: 14px;
      line-height: 15px;
      padding: 0;
      transform: translateY(3px);
      svg {
        width: auto;
        height: 14px;
        .fill {
          fill: ${props => props.theme.color.modalgray};
        }
      }
    }
    .live-tag-icon, .mix-tag-icon {
      width: auto;
      height: 14px;
      margin-left: 6px;
      transform: translateY(3px);
    }
    .additional-dividend-mark {
      display: inline-block;
      width: 26px;
      height: 26px;
      text-align: center;
      line-height: 23px;
      vertical-align: middle;
      margin-top: -2px;
      margin-left: 5px;
      img {
        width: auto;
        height: 15px;
      }
      & + .oz-cancel {
        margin-left: 4px;
      }
    }
    .betting-history.bet-coupon-tag {
      position:relative;
      top: initial;
      left: initial;
      background: none;
      border: none;
    }
    .oz-cancel {
      position: relative;
      margin-left: 9px;
      color: ${props => props.theme.color.disableBg};
      font-weight:  ${props => props.theme.fontW.medium};
      text-decoration: underline;
      &--icon {
        position: relative;
        width: 14px;
        height: 14px;
        margin-left: 2px;
        .img-bg {
          display: inline-block;
          width: inherit;
          height: inherit;
          background: ${props => props.theme.color.themeTxt};
          border-radius: 50%;
          transform: translateY(18%);
        }
        .img {
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 5px;
        }
      }
    }
    .club-list-wrap {
      display: inline-block;
      width: auto;
      height: 14px;
      margin-left: 6px;
      .icon {
        width: auto;
        height: 100%;
        object-fit: contain;
      } 
    }
    // 베팅 내역 퀵메뉴
    .betting-history-quick-menu-btn {
      float: right;
      width: 37px;
      height: 19px;
      color: transparent;
      background: none;
      &::before {
        content: '';
        display: none;
        position: absolute;
        top: 50%;
        right: -2px;
        transform: translateY(-50%);
        width: 19px;
        height: 19px;
        background: ${props => props.theme.color.modalSubBg};
        border-radius: 50%;
        transition: all .3s;
      }
      .ant-popover.betting-history-quick-menu {
        width: 137px;
      }
      .spots {
        position: absolute;
        top: 50%;
        right: 16%;
        transform: translateY(-50%);
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: ${props => props.theme.color.mainBg};
        &::before, &::after {
          content:'';
          display: block;
          position:absolute;
          top: 0;
          left: 0;
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background: ${props => props.theme.color.mainBg};
        }
        &::before {
          top: -5px;
        }
        &::after {
          top: 5px;
        }
      }
      &.ant-popover-open {
        &::before {
          display: block;
        }
      }
    }
  } /* top-info */

  // 아코디언 style
  .ant-collapse {
    width: 100%;
    overflow:hidden;
    background: none !important;
    .ant-collapse-item {
      .ant-collapse-header {
        width: 100%;
        height: auto;
        padding: 0 14px !important;
        background: none;
      }
      .ant-collapse-content {
        margin-top: 12px;
        padding: 0;
        background: ${props => props.theme.color.themeTxt};
        .ant-collapse-content-box {
          padding: 0;
          background: none;
        }
        .bet-history-content {
          height: 36px;
          line-height: 3.6rem;
          .betting-share-select-btn {
            width: 100%;
            height: 24px;
            font-size: ${props => props.theme.font.small};
          }
        }
      }
      &-active {
        .betting-history-header .fold-money-list--item.fold .arrow-ico {
          transform: translateY(-1px) rotate(180deg);
        }
      }
    }
  }
  .division-line {
    width: 100%;
    height: 1px;
    background: ${props => props.theme.color.modalSubBg2};
    box-shadow: 0 1px 1px rgba(255, 255, 255, .7);
    &.header {
      background: ${props => props.theme.color.modalSubBg};
      box-shadow: 0 1px 1px ${props => props.theme.color.themeTxt};
    }
  }
  // 베팅내역 header
  .betting-history-header {
    .my-bet-info {
      display:flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 29px;
      margin: 14px 0;
      // 적중/미적중/적특 상태 이미지
      .hit-state-img {
         width: auto;
         height: 33px;
      }
      .match-state {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px;
        width: 61px;
        margin-left: 10px;
        &--circle {
          display: inline-block;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          &.ongoing {
            background: ${props => props.theme.color.themeTxt};
            border: 1px solid ${props => props.theme.color.modalgray};
          }
          &.success {
            background: ${props => props.theme.color.secondaryBg};
          }
          &.cancel {
            background: ${props => props.theme.color.purple};
          }
        }
       }
      // 베팅 금액, 배당
      &--list {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 13px;
        &--item {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: ${props => props.theme.font.xlarge};
          color: ${props => props.theme.color.modalTxt};
          // 베팅 금액
          &.money {
            position: relative;
            width: 125px;
            padding-right: 22px;
            &::before {
              content: '';
              position: absolute;
              top: 50%;
              right: 0;
              transform: translateY(-50%);
              width: 1px;
              height: 14px;
              background: ${props => props.theme.color.modalSubBg};
              box-shadow: 1px 0 1px ${props => props.theme.color.themeTxt};
            }
          }
          // 배당
          &.rate {
            width: 76px;
            text-align: right;
          }
          svg {
            width: 18px;
            min-width: 18px;
            margin-left: 4px;
          }
        }
      }
    } /* my-bet-info */
    .fold-money-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: auto;
      line-height: 1.8rem;
      padding: 12px 7px 3px 4px;
      overflow: hidden;
      &--item {
        display: flex;
        align-items: center;
        &.fold {
          .arrow-ico {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            transform: translateY(-1px);
            width: 16px;
            height: 16px;
            margin-right: 9px;
            background: rgba(183, 183, 183, .5);
            border-radius: 50%;
            svg {
              width: inherit;
              path {
                &#bg {
                  fill: none;
                }
                &#arrow {
                  fill: ${props => props.theme.color.modalTxt};
                }
              }
            }
          }
          .sports-ico-wrap {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            margin-left: 14px;
            transform: translateY(-1px);
            img {
              width: 14px;
              height: auto;
            }
          }
          .fold-count {
            font-size: ${props => props.theme.font.large};
            color: ${props => props.theme.color.modalTxt};
          }
        }
        &.final-dividend {
          color: ${props => props.theme.color.btn};
          font-weight:  ${props => props.theme.fontW.medium};
          .final-dividend-value {
            ${TxtLimit};
            width: 90px;
            color: ${props => props.theme.color.modalTxt};
            font-size: ${props => props.theme.font.large};
            text-align: right;
          }
          // Gmoeny icon
          svg {
            width: 14px;
            margin-left: 4px;
          }
        }
      }
    }
  }
`
export const BettingHistoryQuickMenu = styled.div`
  .quick-menu-list {
    margin-bottom: 10px;
    border-bottom: 1px solid ${props => props.theme.color.modalBg};
    &--item {
      margin-bottom: 10px;
    }
  }
  .history-quick-btn {
    display: flex;
    align-items: center;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    background: ${props => props.theme.color.modalBg};
    color: ${props => props.theme.color.modalTxt};
    font-weight: ${props => props.theme.fontW.medium};
    border-radius: 7px;
    &.disabled {
      svg {
        width: 12px;
        margin-right: 7px;
      }
    }
    &--img, svg {
      width: 14px;
      height: auto;
      margin-right: 7px;
    }
  }
  .betting-club {
    text-align: center;
    font-weight: ${props => props.theme.fontW.medium};
    .club-txt {
      display: inline-block;
      margin: 0 5px 5px 0;
      color: ${props => props.theme.color.btn};
      font-weight: ${props => props.theme.fontW.medium};
    }
    .history-quick-btn {
      margin-bottom: 0;
    }
  }
  &.no-border {
    .quick-menu-list {
      border: none;
      margin-bottom: 0;
      &--item {
        margin-bottom: 0;
      }
    }
  }


`

// 지울 예정
export const BetHistoryListWrap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items:center;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  .list-header-info {
    display: flex;
    justify-content: flex-start;
    align-items:center;
    flex: 3;
    height: 24px;
    svg {
      top: -1px;
    }
  }
  .list-header-pick-btn {
    flex: 2;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    & > span {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .share-btn:nth-of-type(1) {
      margin-right: 6px;
    }
  }
  // 저장 내역 베팅 버튼
  .saved-bet-header {
    display: flex;
    align-items: center;
    width: 100%;
    &.top {
      justify-content: space-between;
    }
    &.bottom {
      //margin-top: 12px;
      .fold-num {
        //padding-right: 12px;
      }
      .rate-txt {
        margin-left: 12px;
        padding-left: 12px;
        border-left: 1px solid ${props => props.theme.color.btn};
      }
      .rate-num {
        margin-right: 8px;
        color: ${props => props.theme.color.yellow};
      }
      .circle {
        top: 0;
      }
    }
  }
  .do-bet-btn {
    width: 56px;
    height: 24px;
    line-height: 2.5rem;
    font-size: ${props => props.theme.font.small};
  }
  // 선택된 베팅 내역 (메세지)
  &.selected {
    top: -5px;
  }
`

export const UserPickBannerH = '80px'
export const UserPickBannerStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 14px;
  position: relative;
  height: auto;
  img {
    width: auto;
    max-width: 100%;
    border-radius: 4px;
    max-height: ${UserPickBannerH};
    box-shadow: 0 2px 6px #00000038;
  }
  &.bet-slip{
    width: auto;
    //max-height: 87px;
    padding: 0;
    img {
      max-height: 87px;
      box-shadow: none;
    }
    &.pc{
      margin-top: 8px;
      margin-left: 0;
      padding-bottom: 2px;
      padding-left: 0;
    }
  }
`
